/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/child-care': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M14 3.01v6.92h8a8 8 0 00-6.86-7.92c-.6-.09-1.14.39-1.14 1zm6.32 12.81A7.948 7.948 0 0022 10.93H7.44L6.76 9.5a.993.993 0 00-.9-.57H4c-.55 0-1 .45-1 1s.45 1 1 1h1.22S7.11 15 7.34 15.35a3.505 3.505 0 00-1.74 3.94c.3 1.26 1.34 2.27 2.6 2.55 2.1.46 3.98-.96 4.25-2.91h2.08a3.498 3.498 0 004.22 2.92 3.493 3.493 0 002.63-2.53c.35-1.39-.14-2.68-1.06-3.5zM9 19.93c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" _fill="#000" fill-rule="evenodd"/>'
  }
})
